module.exports = __webpack_public_path__ + "img/finance_6.22f19140.png";